import { addDays, format, startOfWeek, startOfMonth, endOfMonth, endOfWeek, parseISO } from 'date-fns';

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const COURTS = [1, 2];
export const OPEN_HOUR = 8;
export const CLOSE_HOUR = 21;
export const HOURS = Array.from({ length: CLOSE_HOUR - OPEN_HOUR }, (_, i) => OPEN_HOUR + i);
export const BLOCK_MEMBER_ID = 'admin-block';

export const toKey = (d) => format(d, 'yyyy-MM-dd');
export const hourOf = (slot) => parseInt(slot.split(':')[0], 10);
export const pad = (h) => `${String(h).padStart(2, '0')}:00`;
export const isBlock = (b) => b.member_id === BLOCK_MEMBER_ID || b.booking_type === 'block';

export const weekDays = (anchor) => {
  const start = startOfWeek(anchor, { weekStartsOn: 1 });
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
};

export const monthGrid = (anchor) => {
  const start = startOfWeek(startOfMonth(anchor), { weekStartsOn: 1 });
  const end = endOfWeek(endOfMonth(anchor), { weekStartsOn: 1 });
  const days = [];
  for (let d = start; d <= end; d = addDays(d, 1)) days.push(d);
  return days;
};

export const rangeFor = (view, anchor) => {
  if (view === 'day') return [anchor, anchor];
  if (view === 'week') { const w = weekDays(anchor); return [w[0], w[6]]; }
  const g = monthGrid(anchor);
  return [g[0], g[g.length - 1]];
};

export const bookingAt = (bookings, dateKey, court, hour) =>
  bookings.find(
    (b) => b.date === dateKey && b.court_number === court && b.status !== 'cancelled' &&
      hour >= hourOf(b.time_slot) && hour < hourOf(b.time_slot) + (b.duration_hours || 1)
  );

export const bookingPhase = (b) => {
  const now = new Date();
  const start = parseISO(`${b.date}T${b.time_slot}:00`);
  const end = new Date(start.getTime() + (b.duration_hours || 1) * 3600 * 1000);
  if (end < now) return 'past';
  if (start <= now) return 'active';
  return 'upcoming';
};

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
  'Content-Type': 'application/json',
});

export const apiFetch = async (path, options = {}) => {
  const res = await fetch(`${API_URL}/api/tennis${path}`, { ...options, headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'Noe gikk galt');
  return data;
};
